import React, { useState, useEffect } from 'react';
import { db } from '../firebase/firebase-config';
import { collection, getDocs, updateDoc, doc, query, limit, addDoc } from 'firebase/firestore';
import { MapPin, Phone, Mail, Instagram, Linkedin, Facebook, Save, Loader2, CheckCircle, Settings } from 'lucide-react';
import './ContactManager.css';
import { AnimatePresence } from 'framer-motion';

const ContactManager = () => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');
  const [settingsId, setSettingsId] = useState(null);
  const [info, setInfo] = useState({
    address: '', phone: '', email: '', 
    instagram: '', linkedin: '', facebook: '',
    mapIframe: '' 
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const settingsSnap = await getDocs(query(collection(db, "settings"), limit(1)));
        if (!settingsSnap.empty) {
          setSettingsId(settingsSnap.docs[0].id);
          setInfo(settingsSnap.docs[0].data());
        }
      } catch (error) {
        console.error("Bilgiler getirilemedi:", error);
      }
    };
    fetchSettings();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (settingsId) {
        await updateDoc(doc(db, "settings", settingsId), info);
      } else {
        // Eğer koleksiyon boşsa yeni döküman oluşturur kanka
        await addDoc(collection(db, "settings"), info);
      }
      setStatus('success');
      setTimeout(() => setStatus(''), 3000);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  return (
    <div className="contact-manager-container">
      <div className="admin-header-flex">
        <h3 style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Settings size={24} color="#1a4731" /> Site İletişim & Harita Ayarları
        </h3>
        <AnimatePresence>
          {status === 'success' && (
            <div className="status-badge success">
              <CheckCircle size={16}/> Değişiklikler Kaydedildi!
            </div>
          )}
        </AnimatePresence>
      </div>

      <div className="admin-full-layout">
        <form className="contact-edit-form-full" onSubmit={handleSave}>
          <div className="admin-section-title">Kurumsal İletişim Bilgileri</div>
          
          <div className="form-group-new">
            <label><MapPin size={16}/> Fabrika Açık Adresi</label>
            <textarea 
              value={info.address} 
              onChange={e => setInfo({...info, address: e.target.value})} 
              rows={2} 
              placeholder="Sitede ve harita altında görünecek adres..." 
            />
          </div>

          <div className="form-group-new">
            <label><MapPin size={16}/> Google Maps Iframe (Embed) Linki</label>
            <textarea 
              value={info.mapIframe} 
              onChange={e => setInfo({...info, mapIframe: e.target.value})} 
              rows={3} 
              placeholder="Google Maps > Paylaş > Harita Yerleştir kısmındaki https://... ile başlayan src linkini buraya yapıştırın kanka." 
            />
          </div>

          <div className="form-row-multi">
            <div className="form-group-new">
              <label><Phone size={16}/> Telefon Numarası</label>
              <input 
                type="text" 
                value={info.phone} 
                onChange={e => setInfo({...info, phone: e.target.value})} 
                placeholder="Örn: +90 352..."
              />
            </div>
            <div className="form-group-new">
              <label><Mail size={16}/> Kurumsal E-Posta</label>
              <input 
                type="email" 
                value={info.email} 
                onChange={e => setInfo({...info, email: e.target.value})} 
                placeholder="info@bigmayem.com.tr"
              />
            </div>
          </div>

          <div className="admin-section-title" style={{ marginTop: '30px' }}>Sosyal Medya Kanalları</div>
          
          <div className="form-row-multi">
            <div className="form-group-new">
              <label><Instagram size={16}/> Instagram URL</label>
              <input type="text" value={info.instagram} onChange={e => setInfo({...info, instagram: e.target.value})} placeholder="https://instagram.com/..." />
            </div>
            <div className="form-group-new">
              <label><Linkedin size={16}/> Linkedin URL</label>
              <input type="text" value={info.linkedin} onChange={e => setInfo({...info, linkedin: e.target.value})} placeholder="https://linkedin.com/in/..." />
            </div>
            <div className="form-group-new">
              <label><Facebook size={16}/> Facebook URL</label>
              <input type="text" value={info.facebook} onChange={e => setInfo({...info, facebook: e.target.value})} placeholder="https://facebook.com/..." />
            </div>
          </div>

          <div className="form-actions-admin">
            <button type="submit" className="save-btn-premium" disabled={loading}>
              {loading ? <Loader2 className="animate-spin" /> : <><Save size={20}/> Ayarları Uygula ve Kaydet</>}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactManager;